import { currentSessionToken } from '../Apis/token';
import axios from "axios";
import { BaseURL } from '../api/DataApis';
const LOCAL_URL = window.location.origin;


const BASE_URL = BaseURL;
const Logoutt = () => {
    // Clear localStorage or any authentication data
    localStorage.removeItem("uniqueToken");
    localStorage.removeItem("userdata");
    localStorage.removeItem("token");
    localStorage.clear(); // Clears all data in localStorage if necessary
  
    // Optionally, you can also clear cookies or session storage if used
    sessionStorage.clear();
  
    // Redirect to login
     window.location.href = `/login`;
  };
const request = async ({ url, method, data = {} }) => {
    
    try {

        let header = await currentSessionToken();
        // console.log(header);
        const axiosInstance = axios.create({
            baseURL: BASE_URL,
            headers: header
        });

        let response = await axiosInstance.request({
            url,
            method,
            data
        });

        if (response && response.data) {
            return response.data;
        }
        return null

    } catch (error) {
        console.error(`API Error in ${method} ${url}:`, error);
        
        if (error.response?.data?.statusCode === 407) {
            Logoutt();
        } else {
        if (error.response) {
            console.error("Response Data:", error.response.data);
            console.error("Status Code:", error.response.status);
            return { error: true, message: error.response.data.message || "Something went wrong!" };
      }
    }

    return { error: true, message: "Network error. Please check your connection." };
  }
}

export default request;